import { Pipe, PipeTransform } from '@angular/core';
import { TimeZones } from '../time-zones';

@Pipe({
    name: 'timezoneSimple',
    standalone: false
})
export class TimezoneSimplePipe implements PipeTransform {
  static DATE_FORMAT: Intl.DateTimeFormatOptions = { month: 'long', day: 'numeric', year: 'numeric' };
  static DATE_FORMAT_WITH_TIME: Intl.DateTimeFormatOptions = { ...TimezoneSimplePipe.DATE_FORMAT, hour: 'numeric', minute: '2-digit', hour12: true };
  static DATE_FORMAT_WITH_TIME_MILITARY: Intl.DateTimeFormatOptions = { ...TimezoneSimplePipe.DATE_FORMAT, hour: '2-digit', minute: '2-digit', hour12: false };

  constructor() {}

  transform(value?: Date | null, timezone: string = TimeZones.UsaEasternTimeKey, useMilitaryTime: boolean = false, includeTime: boolean = true): string {
    if (!value) {
      return '';
    }

    let dateFormat = TimezoneSimplePipe.DATE_FORMAT;

    if (includeTime) {
      dateFormat = useMilitaryTime ? TimezoneSimplePipe.DATE_FORMAT_WITH_TIME_MILITARY : TimezoneSimplePipe.DATE_FORMAT_WITH_TIME;
    }

    const options = { ...dateFormat, timeZone: timezone };
    const formatter = new Intl.DateTimeFormat(Intl.DateTimeFormat().resolvedOptions().locale || 'en-US', options);

    return formatter.format(new Date(value)).replace(' at', '');
  }
}
